import gql from 'graphql-tag';
import * as types from 'DayPlan/DayPlanTypes';

const query = gql`
    query DayPlan($date: Date!, $canBeCopiedToDate: Date!) {
        me {
            id
            goal {
                reachedBecauseOfLoseWeight
                reachedBecauseOfPutOnWeight
                lostBecauseOfLoseWeight
                lostBecauseOfPutOnWeight
            }
            dayPlan(date: $date) {
                __typename
                ... on ${types.UNAUTHORIZED} {
                    code
                }
                ... on ${types.DAY_REDIRECT} {
                    date
                }
                ... on ${types.OUTSIDE_ACCESS} {
                    __typename
                }
                ... on ${types.PAYMENT_PENDING} {
                    token
                    description
                    originatesFromWeb
                }
                ... on ${types.DIET_IN_FUTURE} {
                    date
                }
                ... on ${types.DAY_PLAN} {
                    id
                    date
                    canBeCopiedToDate(targetDate: $canBeCopiedToDate)
                    events {
                        __typename
                        ... on Meal {
                            name
                            id
                            key
                            original {
                                id
                                dishes {
                                    id
                                    name
                                    ingredients{
                                        name
                                    }
                                }
                                preparationImageUrl
                            }
                            kcal
                            macro {
                                protein {
                                    grams
                                    kcal
                                    percentage
                                }
                                animalProtein {
                                    grams
                                    kcal
                                    percentage
                                }
                                fat {
                                    grams
                                    kcal
                                    percentage
                                }
                                carbohydrates {
                                    grams
                                    kcal
                                    percentage
                                }
                            }
                            preparationTime {
                                years
                                months
                                days
                                hours
                                minutes
                                seconds
                            }
                            dishes {
                                id
                                key
                                name
                                recipe
                                recipeNote
                                hasReplacement
                                isPortioned
                                portions
                                portionsTotal
                                isFirstOccurance
                                isLastOccurance
                                ingredients {
                                    key
                                    productAmountId
                                    productId
                                    name
                                    hasReplacement
                                    category {
                                        id
                                        isSeasoning
                                        isOptional
                                        name
                                    }
                                    measurements {
                                        amount
                                        unit
                                        text
                                    }
                                    original {
                                        productId
                                        name
                                        measurements {
                                            amount
                                            unit
                                            text
                                        }
                                    }
                                    replacements {
                                        productId
                                        name
                                        measurements {
                                            amount
                                            unit
                                            text
                                        }
                                    }
                                    saleProductVariant {
                                        id
                                        variantName
                                        name
                                        shortPromo
                                        thumbnailUrl
                                        purchaseId
                                    }
                                    note{
                                        title
                                        content
                                        media {
                                            __typename
                                            ... on IngredientNoteMediaImage {
                                                imageUrl
                                            }
                                            ... on IngredientNoteMediaVideo {
                                                posterUrl
                                                videoUrl
                                            }
                                        }
                                    }
                                }
                            }
                            preparationVideoUrl
                            preparationImageUrl
                            publicName
                        }
                    }
                    diet {
                        id
                        dietId
                        isVegetarian
                        isPescoVegetarian
                        isForSportsman
                        name
                        kcal
                        macro {
                            protein {
                                grams
                                kcal
                                percentage
                            }
                            animalProtein {
                                grams
                                kcal
                                percentage
                            }
                            fat {
                                grams
                                kcal
                                percentage
                            }
                            carbohydrates {
                                grams
                                kcal
                                percentage
                            }
                        }
                        phase {
                            name
                            identifier
                        }
                    }
                    showMacros
                }
            }
            diet {
                dietId:id
                isVegetarian,
                isPescoVegetarian,
                availableDays {
                    date
                    holiday {
                        identifier
                        name
                        description
                        icon
                    }
                    dayPlan {
                        diet {
                            id
                            name
                            phase{
                                identifier
                                name
                            }
                        }
                    }
                }
                accessTo
                nextDaySet: set(date: $canBeCopiedToDate) {
                    ... on UserDietSet {
                        dietSetId
                    }
                }
                set(date: $date) {
                    ... on UserDietSet {
                        dietSetId
                        userDietSetId
                        holiday {
                            identifier
                            name
                            description
                            icon
                        }
                        categories{
                            id
                            name
                        }
                    }
                }
                mealsEaten(date: $date) {
                    mealId
                }
            }
            activeSubscriptions {
                givesAccessToDiet
            }
            isTimeToNagForCurrentMeasurement
            fastingStatistics {
                dietsCount
                currentDietLength
                currentDietProgress
            }
        }
    }
`;

export default query;
